
import { declareVueComponent, registerVueComponentAndAngularBindings } from '../vvuejs/vueRegister.mjs'

// import FCostSlider from './components/FCostSlider.vue'
registerVueComponentAndAngularBindings('vcost_slider:component', 'fCostSlider', resolve => import('./components/FCostSlider.vue').then(resolve))